import { useQuery, useSubscription } from "@apollo/client";
import { useWorker } from "@koale/useworker";
import gql from "graphql-tag";
import * as Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { UsersSearchContext } from "../../../Context/UsersSearchContext/UsersSearchContext";
import getCurrentUserInformation from "../../../GraphQL/Query/getCurrentUserInformation";
import { Icon } from "../../Icon/Icon";
import { Button } from "../../SharedComponents/Button/Button";
import { SearchBox } from "../../SharedComponents/SearchBox/SearchBox";
import { AdminPageHeader } from "../AdminPageHeader/AdminPageHeader";
import { AdminRightActionsContainer } from "../AdminRightActionsContainer/AdminRightActionsContainer";
import { AdminUsersList } from "../AdminUsersList/AdminUsersList";
import "./AdminUsers.css";

const getUsersQuery = gql`
  query {
    users {
      id
      name
      email
      status
    }
  }
`;

const filterUsers = (users, searchTerm) => {
  return users.filter((x) => {
    return (
      x?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      x.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });
};

export const AdminUsers = () => {
  useSubscription(onAnySSOUserUpdatedSubscription);

  const { t } = useTranslation();
  const id = Cookies.get("primary_account");
  const { data: currentUserData } = useQuery(getCurrentUserInformation);
  const { data, loading } = useQuery(getUsersQuery, {
    fetchPolicy: "network-only",
  });
  const { searchTerm, setSearchTerm } = useContext(UsersSearchContext);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const history = useHistory();
  const [filterWorker, { kill: killWorker }] = useWorker(filterUsers);

  useEffect(() => {
    if (searchTerm === "") {
      setFilteredUsers(data?.users || []);
    } else {
      // Kill the worker if it's still running
      killWorker();

      const users = data?.users || [];
      filterWorker(users, searchTerm).then((data) => {
        setFilteredUsers(data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchTerm, filterWorker]);

  const canEdit =
    currentUserData?.user?.roles?.sso?.find((x) => x.accountId === id)?.role !==
    "SUPPORTER";

  return (
    <div className="AdminUsers">
      <div className="AdminDistributors__content">
        <AdminPageHeader title={t("menu.users")} />
        <AdminUsersList
          users={filteredUsers}
          title={[t("generic.name"), t("generic.email"), t("generic.status")]}
          loading={loading}
        />
      </div>
      <div className="AdminDistributors__right">
        <div className="AdminDistributors__search">
          <SearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
        <div className="AdminDistributors__actions">
          <AdminRightActionsContainer>
            <div className="AdminDistributors__add-new">
              {canEdit && (
                <Button
                  buttonStyle="Button__primary"
                  click={() => history.push("/admin/users/invite-user")}
                >
                  <Icon
                    className="AdminRightActionsContainer__add-new--icon"
                    name="iconAdd"
                    width={12}
                    height={12}
                  />
                  <div className="AdminRightActionsContainer__add-new--text">
                    {t("generic.addNew")}
                  </div>
                </Button>
              )}
            </div>
          </AdminRightActionsContainer>
        </div>
      </div>
    </div>
  );
};

const onAnySSOUserUpdatedSubscription = gql`
  subscription onAnySSOUserUpdated {
    onAnySSOUserUpdated {
      id
      email
      name
      roles
      passwordChangedAt
      status
    }
  }
`;
